function compareTwoStrings(str1, str2) {
  if (!str1.length && !str2.length) return 1; // if both are empty strings
  if (!str1.length || !str2.length) return 0; // if only one is empty string
  if (str1.toUpperCase() === str2.toUpperCase()) return 1; // identical
  if (str1.length === 1 && str2.length === 1) return 0; // both are 1-letter strings

  var pairs1 = wordLetterPairs(str1);
  var pairs2 = wordLetterPairs(str2);
  var union = pairs1.length + pairs2.length;
  var intersection = 0;
  pairs1.forEach(function (pair1) {
    for (var i = 0, pair2; pair2 = pairs2[i]; i++) {
      if (pair1 !== pair2) continue;
      intersection++;
      pairs2.splice(i, 1);
      break;
    }
  });
  return intersection * 2 / union;
}
function flattenDeep(arr) {
  return Array.isArray(arr) ? arr.reduce(function (a, b) {
    return a.concat(flattenDeep(b));
  }, []) : [arr];
}
function letterPairs(str) {
  var pairs = [];
  for (var i = 0, max = str.length - 1; i < max; i++) {
    pairs[i] = str.substring(i, i + 2);
  }
  return pairs;
}
function wordLetterPairs(str) {
  var pairs = str.toUpperCase().split(' ').map(letterPairs);
  return flattenDeep(pairs);
}
export { compareTwoStrings };